import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { motion } from "framer-motion";
import { Modal } from "react-bootstrap";
import Spinner from "../../reusables/spinner";
import OrderDetails from "./orderDetails";
import {
  animationValues,
  transitionValues,
} from "../../../utils/pageTransitions";
import Dropdown from "../../reusables/dropdown";
import InputField from "../../reusables/input";
import {
  allocate_order,
  fetch_selectedSuppliers,
  get_orders,
  refund,
} from "../../../redux/actions/adminActions";
import Pagination from "../../reusables/pagination";

function CancelledOrders({
  accessToken,
  getOrders,
  orders,
  getSelectedSuppliers,
  selectedSuppliers,
  allocateOrder,
  refund,
}) {
  const [loading, setLoading] = useState(true);

  const token = accessToken;
  let params = {};
  let status = "cancelled";

  useEffect(() => {
    getOrders({ token, status, success });
  }, []);

  const success = () => {
    setLoading(false);
  };

  const [filteredOrder, setOrders] = useState([]);

  const [optionsActive, setOptions] = useState(null);

  const [orderDetails, setOrder] = useState(false);

  const [selectedOrder, setSelect] = useState([]);

  const [allocate, setAllocate] = useState(false);

  const [active, setActive] = useState(0);

  const handleSelect = (id) => {
    setSelect(id);
    setOrder(true);
  };

  const [search, setSearch] = useState("");

  const [hasFilter, setFilter] = useState(false);

  const searchHandler = (e) => {
    if (search !== "") {
      const searchResults = orders.filter((i) => i.order_id == search);
      setOrders(searchResults);
      setFilter(true);
    } else {
      setFilter(false);
    }
  };

  const handleSelectSupplier = (id) => {
    getSelectedSuppliers(id, accessToken, setLoading(false));
    setAllocate(true);
  };

  const handleRefund = (id) => {
    setLoading(true);
    refund(id, accessToken, setLoading(false));
    // setAllocate(true);
  };

  const handleAllocate = () => {
    allocateOrder(optionsActive, active, accessToken, () => setAllocate(false));
  };

  const onPageChange = (page) => {
    setLoading(true);
    params = { ...params, ...{ page: page } };
    getOrders({ token, status, success, params });
  };

  const handleSearch = (e) => {
    let value = e.target.value;
    if (value == "") return;
    setLoading(true);
    params = { ...params, ...{ search: value } };
    getOrders({ token, status, success, params });
  };

  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={animationValues}
      transition={transitionValues}
    >
      <div className="pt-3">
        <div className="spaceBetween mobileBlock">
          <div className="searchHolder">
            <InputField
              name={search}
              iconClick={searchHandler}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search by order ID"
              icon
              iconClass="ri-search-line"
              onChange={handleSearch}
            />
          </div>

          {/* <div className="alignOnly pt-2">
                        <Dropdown value="All dates" className='mx-1'/>
                        <Dropdown value="Status" className='mx-1'/>
                    </div> */}
        </div>

        {loading ? (
          <Spinner big />
        ) : (
          <div className="sectionHeight--mid scrollable--mobile pt-4">
            <table className="table table__custom">
              <thead className="sectionText--small textIsGray table__head pb-2">
                <tr className="">
                  <th className="">Order Number</th>
                  <th className="vAlign">Date</th>
                  <th className="vAlign">Total Products Cost</th>
                  <th className="vAlign">Total Handling Cost</th>
                  <th className="vAlign">Delivery Cost</th>
                  <th className="vAlign">Sub Total</th>
                  <th className="vAlign">Exch. Rate</th>
                  <th className="vAlign">Platform Fee</th>
                  <th className="vAlign">VAT</th>
                  <th className="vAlign">Profit Per Order</th>
                  <th className="vAlign">Customer</th>
                  <th className="vAlign">Status</th>
                  <th className="vAlign">Action</th>
                </tr>
              </thead>
              <tbody className="">
                {hasFilter
                  ? filteredOrder?.map((order) => (
                      <tr className="hasRadius">
                        <td className="alignOnly pt-3">
                          <input
                            type="checkbox"
                            className="isClickable"
                            name=""
                            id=""
                          />

                          <p className="mb-0  sectionText mx-2">
                            #{order.sub_order_id}
                          </p>
                        </td>

                        <td className="pt-3 vAlign">
                          <p className="mb-0  sectionText">{order.date}</p>
                        </td>

                        <td className="pt-3 vAlign">
                          <p className="mb-0  sectionText">
                            ₦{order.items_total}
                          </p>
                        </td>

                        <td className="pt-3 vAlign">
                          <p className="mb-0  sectionText">
                            ₦{order.platform_fee}
                          </p>
                        </td>

                        <td className="pt-3 vAlign">
                          <p className="mb-0  sectionText">₦{order.vat}</p>
                        </td>

                        <td className="vAlign pt-3">
                          <p className="mb-0 sectionText">
                            ₦{order.handling_cost}
                          </p>
                        </td>

                        <td className="vAlign pt-3 address">
                          <p className="mb-0 sectionText">
                            ₦{order.delivery_cost}
                          </p>
                        </td>

                        <td className="vAlign pt-3">
                          <p className="mb-0  sectionText">
                            ₦{order.sub_total}
                          </p>
                        </td>

                        <td className="vAlign pt-3">
                          <p className="mb-0  sectionText">
                            ₦{order.exchange_rate}
                          </p>
                        </td>

                        <td className="vAlign pt-3">
                          <p className="mb-0  sectionText">
                            ₦{order.profit_per_order}
                          </p>
                        </td>

                        <td className="vAlign pt-3">
                          <p className="mb-0  textIsGreen sectionText">
                            {order.customer?.first_name}
                          </p>
                        </td>

                        <td className="vAlign pt-3">
                          <p
                            className={`mb-0  tag ${
                              order.order_status === "pending" && "pending"
                            }`}
                          >
                            {order.order_status}{" "}
                          </p>
                        </td>

                        <td className="vAlign pt-3">
                          <i
                            class="ri-more-line isClickable"
                            onClick={
                              optionsActive === order.id
                                ? () => setOptions(null)
                                : () => setOptions(order.id)
                            }
                          ></i>

                          {optionsActive === order.id && (
                            <div className="options">
                              <div className="caret"></div>
                              <div className="p-2 textIsBold lAlign sectionText--small">
                                <div
                                  className="hasBorder--bottom pb-2"
                                  onClick={() => handleSelect(order.id)}
                                >
                                  Order Details
                                </div>
                                <div
                                  className="pt-2 pb-2 hasBorder--bottom"
                                  onClick={() => handleSelectSupplier(order.id)}
                                >
                                  Re-allocate
                                </div>
                              </div>
                            </div>
                          )}
                        </td>
                      </tr>
                    ))
                  : orders?.data.map((order) => (
                      <tr className="hasRadius">
                        <td className="alignOnly pt-3">
                          <input
                            type="checkbox"
                            className="isClickable"
                            name=""
                            id=""
                          />

                          <p className="mb-0  sectionText mx-2">
                            #{order.sub_order_id}
                          </p>
                        </td>

                        <td className="pt-3 vAlign">
                          <p className="mb-0  sectionText">{order.date}</p>
                        </td>

                        <td className="pt-3 vAlign">
                          <p className="mb-0  sectionText">
                            ₦{order.items_total}
                          </p>
                        </td>

                        <td className="pt-3 vAlign">
                          <p className="mb-0  sectionText">
                            ₦{order.platform_fee}
                          </p>
                        </td>

                        <td className="pt-3 vAlign">
                          <p className="mb-0  sectionText">₦{order.vat}</p>
                        </td>

                        <td className="vAlign pt-3">
                          <p className="mb-0 sectionText">
                            ₦{order.handling_cost}
                          </p>
                        </td>

                        <td className="vAlign pt-3 address">
                          <p className="mb-0 sectionText">
                            ₦{order.delivery_cost}
                          </p>
                        </td>

                        <td className="vAlign pt-3">
                          <p className="mb-0  sectionText">
                            ₦{order.sub_total}
                          </p>
                        </td>

                        <td className="vAlign pt-3">
                          <p className="mb-0  sectionText">
                            ₦{order.exchange_rate}
                          </p>
                        </td>

                        <td className="vAlign pt-3">
                          <p className="mb-0  sectionText">
                            ₦{order.profit_per_order}
                          </p>
                        </td>

                        <td className="vAlign pt-3">
                          <p className="mb-0  textIsGreen sectionText">
                            {order.customer?.first_name}
                          </p>
                        </td>

                        <td className="vAlign pt-3">
                          {/* <p className={ `mb-0  tag ${order.order_status === 'pending' && 'pending'}` }>{ order.order_status } </p> */}
                          <p
                            className={`mb-0  tag ${
                              order.order_status === "Not refunded"
                                ? "pending"
                                : "done"
                            }`}
                          >
                            {order.order_status}{" "}
                          </p>
                        </td>

                        <td className="vAlign pt-3">
                          <i
                            class="ri-more-line isClickable"
                            onClick={
                              optionsActive === order.id
                                ? () => setOptions(null)
                                : () => setOptions(order.id)
                            }
                          ></i>

                          {optionsActive === order.id && (
                            <div className="options">
                              <div className="caret"></div>
                              <div className="p-2 textIsBold lAlign sectionText--small">
                                <div
                                  className="hasBorder--bottom pb-2"
                                  onClick={() => handleSelect(order.id)}
                                >
                                  Order Details
                                </div>
                                {order.refund_status == 0 && (
                                  <>
                                    <hr class="my-0" />
                                    <div
                                      className="pt-2 pb-2 hasBorder--bottom"
                                      onClick={() => handleRefund(order.id)}
                                    >
                                      Mark as Refunded
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          )}
                        </td>
                      </tr>
                    ))}
              </tbody>
            </table>
          </div>
        )}
        <div className="d-flex justify-content-end">
          <Pagination
            onChange={onPageChange}
            page={orders?.current_page}
            total={orders?.total}
            per_page={orders?.per_page}
          />
        </div>
      </div>

      <Modal show={orderDetails} onHide={() => setOrder(false)} centered>
        <div className="sectionHeight--mid py-3">
          <OrderDetails orderID={selectedOrder} allocated />
        </div>
      </Modal>
    </motion.div>
  );
}

const mapStateToProps = (state) => ({
  accessToken: state.admin.token,
  orders: state.admin.orders,
  selectedSuppliers: state.admin.selectedSuppliers,
});

const mapDispatchToProps = (dispatch) => ({
  getOrders: (token, status, success) =>
    dispatch(get_orders(token, status, success)),
  getSelectedSuppliers: (id, token, success) =>
    dispatch(fetch_selectedSuppliers(id, token, success)),
  allocateOrder: (id, supplier_id, token, success) =>
    dispatch(allocate_order(id, supplier_id, token, success)),
  refund: (id, token, success) => dispatch(refund(id, token, success)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CancelledOrders);
